import React from 'react';
import { InputLeftAddon, InputRightElement, Spinner, Text } from '@chakra-ui/react';
import { FormControl } from 'src/components/UI/FormControl';
import { FormErrorMessage } from 'src/components/UI/FormErrorMessage';
import { InputGroup } from 'src/components/UI/Input/InputGroup';
import { MaskedInput } from 'src/components/UI/Input/MaskedInput';
import { colors } from 'src/theme/colors';
import { Flex } from 'src/components/UI/Flex';

interface RegisterNumberInputProps {
  counsel: 'CRM' | 'CRO';
  ufRegister: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  isLoading?: boolean;
  onShowHelp?: () => void;
}

export function RegisterNumberInput({
  counsel,
  ufRegister,
  value,
  onChange,
  onBlur,
  error,
  isLoading = false,
  onShowHelp,
}: RegisterNumberInputProps) {
  const isInvalid = !!error;

  const renderErrorMessage = () => {
    if (!error) return null;

    if (error.includes('RECUPERAR ACESSO')) {
      const parts = error.split('RECUPERAR ACESSO');
      return (
        <Flex flexDirection="column">
          {parts[0]}
          <Text
            as="span"
            textDecoration="underline"
            cursor="pointer"
            onClick={() => {
              onShowHelp?.();
            }}
          >
            RECUPERAR ACESSO
          </Text>
          {parts[1] || ''}
        </Flex>
      );
    }

    return error;
  };

  if (counsel === 'CRM' && ufRegister === 'RJ') {
    return (
      <FormControl isInvalid={isInvalid}>
        <InputGroup>
          <InputLeftAddon
            borderTopLeftRadius="10px"
            borderBottomLeftRadius="10px"
            bg="primary.100"
            color="primary.1000"
            h="45px"
            borderColor="primary.100"
          >
            52
          </InputLeftAddon>
          <MaskedInput
            name="registerNumber"
            borderLeft={0}
            borderTopLeftRadius={0}
            borderBottomLeftRadius={0}
            h="45px"
            placeholder="0000"
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            mask="**99999"
            maskChar=""
            isDisabled={isLoading}
          />
          {isLoading && (
            <InputRightElement pointerEvents="none" h="45px">
              <Spinner size="sm" color="primary.500" />
            </InputRightElement>
          )}
        </InputGroup>
        <FormErrorMessage>{renderErrorMessage()}</FormErrorMessage>
      </FormControl>
    );
  }

  return (
    <FormControl isInvalid={isInvalid}>
      <InputGroup>
        <MaskedInput
          name="registerNumber"
          h="45px"
          placeholder="0000"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          mask="**99999"
          maskChar=""
          borderRadius="10px"
          border="1px solid"
          borderColor={colors.primary['100']}
          isDisabled={isLoading}
        />
        {isLoading && (
          <InputRightElement pointerEvents="none" h="45px">
            <Spinner size="sm" color="primary.500" />
          </InputRightElement>
        )}
      </InputGroup>
      <FormErrorMessage>{renderErrorMessage()}</FormErrorMessage>
    </FormControl>
  );
}
